// extracted by mini-css-extract-plugin
export default {"list":"team_list__E2uL4","listScroll":"team_listScroll__cLtDs","sp":"team_sp__0ec1x"};